var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerBenefits4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.49 2C6.97 2 2.5 6.48 2.5 12C2.5 17.52 6.97 22 12.49 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.49 2ZM16.5 16C16.4075 16.0927 16.2976 16.1663 16.1766 16.2164C16.0557 16.2666 15.926 16.2924 15.795 16.2924C15.664 16.2924 15.5343 16.2666 15.4134 16.2164C15.2924 16.1663 15.1825 16.0927 15.09 16L11.8 12.71C11.7055 12.6174 11.6303 12.5069 11.5788 12.3851C11.5273 12.2632 11.5005 12.1323 11.5 12V8C11.5 7.45 11.95 7 12.5 7C13.05 7 13.5 7.45 13.5 8V11.59L16.5 14.59C16.89 14.98 16.89 15.61 16.5 16Z",
    fill: "#9E4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBenefits4);
export default __webpack_public_path__ + "static/media/banner-benefits-4.c15bd943edba3cd805ea71b49ac02f0a.svg";
export { ForwardRef as ReactComponent };